import { render, staticRenderFns } from "./StampToCollect.vue?vue&type=template&id=03785fe4&scoped=true&lang=pug&"
import script from "./StampToCollect.vue?vue&type=script&lang=js&"
export * from "./StampToCollect.vue?vue&type=script&lang=js&"
import style0 from "./StampToCollect.vue?vue&type=style&index=0&id=03785fe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03785fe4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VIcon,VRow})
